import React from "react";
import PropTypes from "prop-types";

const ImageUploader = ({ onUpload, uploading }) => {
  const handleFileChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      onUpload(Array.from(event.target.files));
    }
  };

  return (
    <div className="image-uploader-content-wrapper">
      <span className="uploader-icon">+</span>
      <span className="uploader-text">Add Image{uploading ? "s..." : ""}</span>
      <input
        type="file"
        multiple
        onChange={handleFileChange}
        disabled={uploading}
        title="Add new images"
        aria-label="Add new images"
      />
    </div>
  );
};

ImageUploader.propTypes = {
  onUpload: PropTypes.func.isRequired,
  uploading: PropTypes.bool,
};

ImageUploader.defaultProps = {
  uploading: false,
};

export default ImageUploader;
